module.exports = __webpack_public_path__ + "ae3f44e104c3bb5041c88a613ee6e70f.png";